import * as ActionTypes from "constants/ActionTypes";
import { combineReducers } from "redux";

function visibleIndex(state = -1, action) {
  switch (action.type) {
    case ActionTypes.SET_VISIBLE_CUEPOINT_PREVIEW_INDEX:
      return action.index;
    case ActionTypes.HIDE_CUEPOINT_PREVIEWS:
      return -1;
    default:
      return state;
  }
}

export default combineReducers({
  visibleIndex,
});
